<template>
  <perfect-scrollbar
    v-if="atendenteNome"
    ref="refChatLogPS"
    class="ps-chat-log h-full"
    :options="perfectScrollbarOptions"
  >
    <div class="chat-log pa-5">
      <chat-log-item
        v-for="(mensagem, index) in mensagensFormatadas"
        :key="index"
        :mensagem="mensagem"
        :atendente-nome="atendenteNome"
        :solicitante-nome="solicitanteNome"
        :is-ultima-mensagem="index === mensagensFormatadas.length - 1"
        :pode-responder-mensagem="podeResponderMensagem"
        :ticket-esta-finalizado="ticketEstaFinalizado"
        @mensagem-selecionada-para-resposta="v => $emit('mensagem-selecionada-para-resposta', v)"
      />
    </div>
  </perfect-scrollbar>
</template>

<style lang="scss">
@import '@core/preset/preset/apps/chat.scss';
</style>

<script>
import { ref, computed, watch, nextTick } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import ChatLogItem from './ChatLogItem.vue'
import useUserStore from '@/store/user'

export default {
  emits: ['mensagem-selecionada-para-resposta'],

  components: {
    PerfectScrollbar,
    ChatLogItem,
  },

  props: {
    mensagens: {
      type: Array,
      required: true,
    },
    solicitanteNome: {
      type: String,
      default: '',
    },
    podeResponderMensagem: {
      type: Boolean,
      required: true,
    },
    ticketEstaFinalizado: {
      type: Boolean,
      required: true,
    },
  },

  setup(props) {
    const refChatLogPS = ref(null)

    const perfectScrollbarOptions = {
      maxScrollbarLength: 50,
      wheelPropagation: true,
    }

    function scrollToBottomInChatLog() {
      const scrollEl = refChatLogPS.value?.$el || refChatLogPS.value
      if (!scrollEl) return
      scrollEl.scrollTop = scrollEl.scrollHeight
    }

    watch(
      () => props.mensagens,
      () => {
        nextTick(() => {
          scrollToBottomInChatLog()
          // PerfectScrollbar pode não ter recalculado o scrollHeight ainda após
          // uma substituição completa do array — um segundo disparo garante a posição correta
          setTimeout(scrollToBottomInChatLog, 100)
        })
      },
      {
        immediate: true,
        deep: true,
      },
    )

    const { nome: atendenteNome } = storeToRefs(useUserStore())

    const mensagensFormatadas = computed(() => props.mensagens.reduce((acc, msg) => {
      // MANTER O SCRIPT DE AGRUPAMENTO PARA CASO PRECISE DESSA FUNCIONALIDADE NOVAMENTE
      // const lastGroup = acc[acc.length - 1]
      // if (lastGroup && lastGroup.senderId === msg.tipoAtor.id) {
      //   lastGroup.messages.push({
      //     content: msg.conteudoTexto,
      //     time: msg.dataCadastro,
      //     error: msg.error,
      //     canalTipoId: msg.idTipoCanalMensagem,
      //     tipoAtorId: msg.tipoAtor.id,
      //   })
      // } else {
      // }

      acc.push({
        id: msg.id,
        tipoAtorId: msg.tipoAtor.id,
        conteudoTexto: msg.conteudoTexto,
        mensagemReferenciaConteudoTexto: msg.mensagemReferenciaConteudoTexto,
        dataCadastro: msg.dataCadastro,
        canalTipoId: msg.canalTipoId,
        anexos: msg.anexos,
        chatBotProvedorComunicacaoId: msg.chatBotProvedorComunicacaoId,
      })

      return acc
    }, []))

    return {
      refChatLogPS,
      perfectScrollbarOptions,
      mensagensFormatadas,
      atendenteNome,
    }
  },
}
</script>
